import { Controller } from "stimulus"

export default class extends Controller {

  openUrl(event) {
    var url = this.element.dataset.url
    location.assign(url)
  }
}